import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom"
import Api from '../servicios/api'
import {Header, Titulo, ContenedorHeader, ContenedorBotones} from '../elementos/Header'
import {ContenedorBotonesLista, BotonEditar, BotonEliminar} from '../elementos/ElementosDeLista'
import {ReactComponent as IconoEditar} from '../imagenes/editar.svg'
import {ReactComponent as IconoBorrar} from '../imagenes/borrar.svg'
import Boton from '../elementos/Boton'
import Alerta from '../elementos/Alerta'
import Cargando from '../elementos/Cargando'
import VentanaModal from '../elementos/VentanaModal'

const ListarMaterial = () => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [materiales, setMaterial] = useState([]);
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [estadoModal, setEstadoModal] = useState(false);
    const [idEliminar, setidEliminar] = useState(0);

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        cargarDatos();
    }, []);

    //Este hook se ejecuta solamente al primer renderizado
    const cargarDatos = () => {
        fetch(Api+"?consultarMateriales")
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setMaterial(datosRespuesta);
        })
        .catch(console.log)
    }

    const handleModal = (id) => {
        setidEliminar(id);
        setEstadoModal(true);
    }

    const borrarRegistro = () => {
        setEstadoModal(false);
        setEstadoAlerta(false);
        setAlerta({});
        
        fetch(Api+"?borrarMaterial="+idEliminar)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            if(datosRespuesta.success === 1){
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'exito',
                    mensaje: 'Material eliminado correctamente.'
                });
                cargarDatos();
            }
            else{
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'error',
                    mensaje: 'No es posible eliminar este material.'
                });
            }
        })
        .catch(console.log)
    }

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <Header>
                    <ContenedorHeader>
                        <Titulo>Lista de Materiales</Titulo>
                        <ContenedorBotones>
                            <Boton to="/crear-material" primario="true">Agregar Material</Boton>
                        </ContenedorBotones>
                    </ContenedorHeader>
                </Header>

                {materiales.success === 0 ?
                <p className='ms-3'>No hay información para mostrar.</p>
                :
                <div className="contenedor-tabla">
                    <div className="card card-tamano">
                        <div className="card-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Nombre de Material</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        materiales.map(
                                            (material)=>(
                                                <tr key={material.Mat_ID}>
                                                    <td>{material.Mat_Nombre}</td>
                                                    <td>
                                                        <ContenedorBotonesLista>
                                                            <BotonEditar title="Actualizar Material" as={Link} to={"/editar-material/"+material.Mat_ID}>
                                                                <IconoEditar />
                                                            </BotonEditar>
                                                            
                                                            <BotonEliminar title="Eliminar Material" onClick={() => handleModal(material.Mat_ID)}>
                                                                <IconoBorrar />
                                                            </BotonEliminar>
                                                        </ContenedorBotonesLista>
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                }
                <Alerta 
                        tipo={alerta.tipo}
                        mensaje={alerta.mensaje}
                        estadoAlerta={estadoAlerta}
                        setEstadoAlerta={setEstadoAlerta}
                />

                <VentanaModal
                        mensajeHeader="Eliminar Material"
                        mensajeBody="¿Está seguro de eliminar el material?"
                        estadoModal={estadoModal}
                        setEstadoModal={setEstadoModal}
                        handleConfirm={borrarRegistro}
                />
            </>
        );
    }
}
 
export default ListarMaterial;